/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import FormattedRelativeWrapper from 'app/components/common/FormattedRelativeWrapper.jsx';
import { Breakpoint, useCurrentBreakpointName } from 'react-socks';

class TrialBanner extends React.Component {
    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);

    }

    componentDidMount() {
        if (gtag) {
            gtag('event', 'view_promotion', {
                'promotion_id': 'trial_banner',
                'promotion_name': 'Trial Banner',
                'creative_name': 'trial_banner.1',
                'creative_slot': 'top-promo-bar',
                items: [
                    {
                        item_id: 'dlvrit_1',
                        item_name: 'dlvr.it premium plan',
                        price: 1.00,
                        quantity: 1
                    }
                ]
            });
        }

    }

    onClick(e) {

        let that = this;

        if (gtag) {
            gtag('event', 'select_promotion', {
                'promotion_id': 'trial_banner',
                'promotion_name': 'Trial Banner',
                'creative_name': 'trial_banner.1',
                'creative_slot': 'top-promo-bar',
                items: [
                    {
                        item_id: 'dlvrit_1',
                        item_name: 'dlvr.it premium plan',
                        price: 1.00,
                        quantity: 1
                    }
                ]
            });

            this.props.persistData('gaPromo', {
                'promotion_id': 'trial_banner',
                'promotion_name': 'Trial Banner',
            });

        }

    }

    render() {
        let link = '/account/subscription/new',
            expirationCopy = '',
            regularCopy = 'Choose a plan to keep your posts flowing';

        if (this.props.user.detail.trialDaysLeft === 0) {
            let now = new moment().tz(this.props.user.detail.timezone),
                trialEnd = new moment(this.props.user.detail.trialEnd).tz(this.props.user.detail.timezone),
                diff = trialEnd.diff(now, 'hours');

            if (diff === 0) {
                diff = trialEnd.diff(now, 'minutes');
                if (diff < 0) {
                    expirationCopy = <span>Your free trial has ended.</span>
                    regularCopy = <span>Choose a plan to restart posting</span>
                } else {
                    let minuteLabel = (diff === 1) ? 'minute' : 'minutes';
                    expirationCopy = <span>Your free trial ends in {diff} {minuteLabel}.</span>
                }
            } else {
                let hourLabel = (diff === 1) ? 'hour' : 'hours';
                expirationCopy = <span>Your free trial ends in {diff} {hourLabel}.</span>
            }


        } else {
            expirationCopy = <span>Your free trial ends in {this.props.user.detail.trialDaysLeft} {this.props.user.detail.trialDaysLeft === 1 ? 'day' : 'days'}.</span>
        }

        // return (
        //     <div>
        //         <div className="icon-wrapper">
        //             <i className="icon ion-calendar"/>
        //         </div>
        //         <span>{expirationCopy} {regularCopy} <a href={link} onClick={this.onClick}>View Plans</a></span>
        //     </div>
        // );

        let bannerText = '';
        if (this.props.user.detail.trialDaysLeft > 1) {
            bannerText = (
                <span>{this.props.user.detail.trialDaysLeft} days left in trial</span>
            );
        } else {
            bannerText = (
                <span>Free trial ends today!</span>
            );
        }

        return (
            <div style={{"justifyContent":"center", "alignItems":"center"}}>
                <div className="icon-wrapper">
                    <i className="icon ion-flash"/>
                </div>
                <span>{bannerText} - <a href={link} onClick={this.onClick}>Upgrade now</a></span>
            </div>
        );
    }

};

TrialBanner.propTypes = {
    context: PropTypes.string
};

TrialBanner.defaultProps = {
    context: 'app'
};

export default TrialBanner;
